import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  CurrentItemQuery,
  SelectedAgencyShortDataQuery
} from '../../../../../graphql/graphql';
import { getSelectedAgencyShortDataQuery } from '../../../../../api/queries';
import {
  SimilarAdsContainer,
  SimilarAdsContent
} from '../../SimilarAdsSection/styled';
import { SectionPlaceholder } from '../../../../Placeholders/SectionPlaceholder';
import { ItemCardPlaceholder } from '../../../../Placeholders/ItemCardPlaceholder';
import { SimilarSpaceSection } from './styled';
import { setError } from '../../../../../actions';
import { SimilarAdsSection } from '../../SimilarAdsSection';
import { AgencyFilter } from '../../../../Agency/AgencyFilter';

interface SimilarAdsBlockProps {
  data?: CurrentItemQuery['item'];
  item?: CurrentItemQuery['item'];
  isResidence: boolean;
  isAgency: boolean;
  setErrorUI: (value: boolean) => void;
}

const mapDispatchToProps = dispatch => {
  return {
    setErrorUI: (errorState: boolean) => dispatch(setError(errorState))
  };
};

const SimilarAdsBlockComponent: React.FC<SimilarAdsBlockProps> = ({
  item,
  data,
  isResidence,
  isAgency,
  setErrorUI
}) => {
  const {
    data: agencyData,
    loading: agencyDataLoading,
    error: agencyDataError
  } = useQuery<SelectedAgencyShortDataQuery>(getSelectedAgencyShortDataQuery, {
    variables: { id: data?.business?.id },
    skip: !data || !isAgency
  });

  useEffect(() => {
    if (agencyDataError) setErrorUI(true);
  }, [agencyDataError]);

  return item && isAgency ? (
    <SimilarAdsContainer>
      <SimilarAdsContent>
        <SimilarSpaceSection>
          {agencyDataLoading && !agencyData ? (
            <SectionPlaceholder>
              {Array.from({ length: 4 }, (_, index) => (
                <ItemCardPlaceholder key={index} isCardsLayout />
              ))}
            </SectionPlaceholder>
          ) : (
            <AgencyFilter
              categories={agencyData?.agency?.itemCategories}
              allCategories={agencyData?.categories}
              agencyId={agencyData?.agency?.id}
              isCurrentItemPage
            />
          )}
        </SimilarSpaceSection>
      </SimilarAdsContent>
    </SimilarAdsContainer>
  ) : (
    <SimilarAdsSection
      isResidence={isResidence}
      categoryId={item?.category?.id || ''}
      leased={item?.leased}
      companyId={item?.company?.id}
      currentItemId={item?.id || ''}
      companyType={item?.company?.targetType}
      categoryPluralName={item?.category?.pluralName}
    />
  );
};

export const SimilarAdsBlock = connect(
  null,
  mapDispatchToProps
)(SimilarAdsBlockComponent);
